import React from "react";

import { Table, Button } from 'reactstrap';


function Cookies() {
    return (
        <>
            <div
                className="page-header section-dark"
                style={{
                    backgroundColor: "#4d4d4d",
                }} />

            <style>
                {".page-header {height: 80px; min-height: unset "}
            </style>


            <div className="Cookies-Page">

                <h1>Politica de Cookies</h1>

                <p>Le informamos que, en cumplimiento de la normativa vigente en materia de protección de datos, este sitio web utiliza cookies propias y de terceros.</p>

                <h2>¿Qué es una cookie?</h2>

                <p>Una cookie es un fichero que se descarga en el dispositivo del usuario cuando se accede a la página web, con la finalidad de almacenar y recuperar información sobre la navegación que se realiza en el dispositivo.
                </p>
                <p>En general, permiten obtener datos relacionados con los usuarios, y pueden utilizarse para finalidades muy diversas, como, por ejemplo, reconocerte como usuario, obtener información sobre tus hábitos de navegación o personalizar la forma en que se muestra el contenido. Los usos concretos que hacemos de estas tecnologías se describen a continuación.</p>

                <h2>¿Qué tipo de cookies existen, cuáles se utilizan y con qué finalidad?</h2>

                <h2>Según la entidad que las gestione:</h2>
                <p>
                    <strong>Cookies propias: </strong> son aquéllas que se envían al equipo terminal del usuario desde un equipo o dominio gestionado por el propio editor y desde el que se presta el servicio solicitado por el usuario.
                </p>
                <p>
                    <strong>Cookies técnicas: </strong> Permiten al usuario la navegación a través de una página web, plataforma o aplicación y la utilización de las diferentes opciones o servicios que en ella existan.

                </p>

               
     
                <h2>Según el plazo de tiempo que permanecen activadas:</h2>

                <p>
                    <strong>Cookies de sesión: </strong> son cookies temporales que permanecen en el archivo de cookies de su navegador hasta que abandone la página web o app,
                    por lo que ninguna queda registrada en el dispositivo del usuario. La información obtenida por medio de estas cookies sirve para analizar las pautas de tráfico de la web o app.
                    A la larga, esto nos permite proporcionar una mejor experiencia para mejorar el contenido y facilitar su uso.

                </p>
                <p>
                    <strong>Cookies permanentes: </strong> son almacenadas en el dispositivo y se identifican de nuevo cada vez que el usuario realiza una nueva visita.
                    Una cookie permanente puede ser accedida y tratada durante un periodo definido por el responsable de la cookie, después de esa fecha dejará de funcionar.
                </p>

                <h2>OIP hace uso de las siguientes cookies</h2>

                <p>
                    - <b>Cookies técnicas:</b> Son aquellas que, tratadas por nosotros o por terceros, permiten al usuario la navegación a través de una página web,
                    plataforma o app y la utilización de las diferentes opciones o servicios que en ella existan
                </p>
                <p>
                    - <b>Cookies de personalización:</b> Permiten al usuario acceder al servicio con algunas características de carácter general predefinidas en
                    función de una serie de criterios en el terminal del usuario como, por ejemplo, el idioma, el tipo de navegador a través del cual accede al servicio,
                    la configuración regional desde donde accede al servicio, etc.
                </p>
                <p>
                    - <b>Cookies de análisis:</b> Permiten al responsable de las mismas, el seguimiento y análisis del comportamiento de los usuarios de los sitios web
                    a los que están vinculadas. La información recogida mediante este tipo de cookies se utiliza en la medición de la actividad de los sitios web,
                    aplicación o plataforma y para la elaboración de perfiles de navegación de los usuarios de dichos sitios, aplicaciones y plataformas, con el fin de
                    introducir mejoras en función del análisis de los datos de uso que hacen los usuarios del servicio.
                
                    <br />
                Esta página web utiliza cookies analíticas de terceros, titularidad del proveedor Google, LLC. Para más información visita el apartado […] de la presente Política.
                </p>

                <h2>Información ampliada de las cookies utilizadas por la web.</h2>
                <p>A continuación le ofrecemos información más detallada sobre la tipología de cookies que utiliza está página web: 
                </p>
                <Table responsive>
                    <thead>
                        <tr>
                            <th>Cookie</th>
                            <th>Tipo</th>
                            <th>Duración</th>
                            <th>Finalidad</th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row"></th>
                            <td>Cookielawinfo-checkbox-necessary:</td>
                            <td></td>
                            <td></td>


                        </tr>
                        <tr>
                            <th scope="row">Técnicas</th>
                            <td>cookielawinfo-checkbox-non-necessary</td>
                            <td>30 minutos</td>
                            <td>Contiene el valor de si se ha aceptado la política de cookies y la Política de privacidad.</td>


                        </tr>
                        <tr>
                            <th scope="row"></th>
                            <td>viewed_cookie_policy:</td>
                            <td></td>
                            <td></td>


                        </tr>
                    </tbody>
                </Table>

                <h2>Cookies de terceros</h2>

                <Table responsive>
                    <thead>
                        <tr>
                            <th>Cookie</th>
                            <th>Tipo</th>
                            <th>Titular</th>
                            <th>Duración</th>
                            <th>Finalidad</th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">_ga</th>
                            <td>Cookie analítica</td>
                            <td>Tercero (Google Analytics)</td>
                            <td>2 años</td>
                            <td></td>

                        </tr>
                        <tr>
                            <th scope="row">_gat</th>
                            <td>Cookie analítica</td>
                            <td>Tercero (Google Analytics)l</td>
                            <td>10 minutos</td>
                            <td>Se usa para diferenciar entre los diferentes objetos de seguimiento creados en la sesión.</td>

                        </tr>
                        <tr>
                            <th scope="row">_gid</th>
                            <td>Cookie analítica</td>
                            <td>Tercero (Google Analytics)</td>
                            <td>24 horas</td>
                            <td>Se usa para distinguir a los usuarios.</td>

                        </tr>
                        <tr>

                        </tr>
                    </tbody>
                </Table>

                <h2>¿Quién utiliza las cookies?</h2>

                <p>
                    La información obtenida a través de las Cookies será incorporada a los tratamientos con las finalidades y plazos indicados en la presente Política.
                </p>
                <p>
                    La base jurídica que legitima estos tratamientos es el consentimiento del usuario, prestado con ocasión de su navegación por la página web; no obstante, el usuario podrá
                    rechazar el uso de Cookies mediante los mecanismos indicados en la presente Política.
                </p>
                <p>
                    Puedes informarte de las transferencias a terceros países que, en su caso, realizan los terceros identificados en esta política de cookies en sus correspondientes políticas (ver los enlaces facilitados en el apartado “Tipos de cookies habilitadas en esta web”).
                </p>

                <h2>Información sobre transferencias internacionales de datos.</h2>

                <p>
                    Serán objeto de transferencia internacional, los datos personales obtenidos a través de las cookies titularidad del Google, L.L.C.., entidad establecida en EE.UU., 
                    adherida a la Decisión de Adecuación Data Privacy Framework, que posibilita el flujo de datos personales de ciudadanos europeos a Estados Unidos, y que se encuentra 
                    en vigor desde el 10 de julio de 2023. Igualmente, hemos suscrito el correspondiente Acuerdo de Encargo de Tratamiento, que puede consultar en el siguiente 
                    link: <br /><a href="https://support.google.com/tagmanager/answer/7207086?hl=es">https://support.google.com/tagmanager/answer/7207086?hl=es</a>
                </p>
                <p>
                    Le garantizamos que se adoptarán las garantías necesarias para proteger la confidencialidad, integridad y disponibilidad de la misma.
                </p>
                

                <h2>¿Cómo cambio mi configuración de cookies?</h2>

                <p>
                    Para revisar su configuración de cookies en este sitio web, acceda al <b>Panel de configuración o pulsando el botón “Configurar”</b>. 
                </p>
                <p>
                    Igualmente, se informa al usuario de que puede configurar sus ajustes en relación con la huella digital que permanece en su navegador,
                    accediendo a las secciones de ayuda o soporte, que le indicamos a continuación:
                </p>
                <p>
                    <strong>Microsoft Explorer:</strong> Puede consultar el <a href="https://support.microsoft.com/es-es/topic/eliminar-y-administrar-cookies-168dab11-0753-043d-7c16-ede5947fc64d" >
                     soporte de Microsoft</a> o la Ayuda del navegador.
                    <br/>
                    <strong>Microsoft Edge:</strong> Puede consultar el <a href="https://support.microsoft.com/es-es/microsoft-edge/eliminar-las-cookies-en-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09">
                    soporte de Microsoft</a> o la Ayuda del navegador.
                    <br />
                    <strong>Firefox:</strong> Puede consultar el <a href="https://support.mozilla.org/es/kb/Borrar%20cookies">
                        soporte de Mozilla</a> o la Ayuda del navegador.
                    <br />
                    <strong>Chrome:</strong> Puede consultar el <a href="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&amp;hl=es">
                     soporte de Google</a> o la Ayuda del navegador.
                    <br/>
                    <strong>Safari:</strong> Puede consultar el <a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac">
                     soporte de Apple</a> o la Ayuda del navegador.
                    <br />
                    <strong>Android:</strong> en Menú - Ajustes - Seguridad y Privacidad - Aceptar cookies para que active o desactive la casilla. Para más información puede consultar el  <a href="https://support.google.com/android/?hl=es#topic=7313011"> 
                     soporte de Google</a>.
                    <br />
                </p>
                <p>
                    Por favor, lea atentamente las instrucciones que se le facilitan en las secciones de ayuda o soporte, así como la manera de activar el “modo privado”,
                    enviar la solicitud “Do Not Track” (“DNT”) para limitar el rastreo de su navegación en determinados sitios web, así como desbloquear determinadas cookies en su navegador.
                </p>
               
                    <h2>Actualizaciones y cambios en la Política de Cookies.</h2>
                
                <p>
                    La variación de las cookies que aparezcan en esta web puede no estar relacionada con la gestión y el mantenimiento de la misma, por lo que se llevan a cabo revisiones periódicas para adecuar la política de cookies.
                </p>
                <p>
                    El titular de la web no asume ninguna responsabilidad por problemas legales o técnicos causados por el incumplimiento por parte del USUARIO de las recomendaciones incluidas y no se hace responsable del contenido y veracidad de las políticas de privacidad de terceros.
                </p>
                <p>
                    Esta Política de Cookies podrá ser modificada en función de exigencias legislativas, reglamentarias, o con la finalidad de adaptar dicha política a las instrucciones dictadas por la Agencia Española de Protección de Datos, por ello se aconseja a los Usuarios que la visiten periódicamente.
                </p>
                <p>
                    En Madrid, a 11 de enero de 2024
                </p>

                <p>Para modificar la configuración puedes pulsar en el siguiente botón</p>
                <Button className="Button-Config-Cookies" onClick={() => window.document.dispatchEvent(new Event("openCookiesDialog"))}>Configurar</Button>
            </div>
        </>
    );
}

export default Cookies;